import {Basic} from '@packages/systems/core/plugins';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {Atom} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Div Block',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
        },
      },
    },
  },
  render: Atom.getConfigShape(Basic.atoms.Block).render,
  fields: {children: TListOfElement},
});

export default config;
